import React, { useEffect } from "react";
import {
  Button,
  DocumentsList,
  FormFieldSet,
  Modal,
  useFormHandler,
} from "../../../../../../components";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployeeByUiidStart,
  updateEmployeeStart,
} from "../../../../../../redux/slices/employee/employeeSlice";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { v4 as uuidv4 } from "uuid";
import { transformFiles } from "../../../../../../utils/transformFiles";
const AddEducationDetails = ({ isOpen, onClose, edit, educationData }) => {
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const initialFormData = {
    education: "",
    fieldOfStudy: "",
    institute: "",
    gpa: "",
    startDate: "",
    endDate: "",
    documents: [],
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      education: { type: "select", required: true },
      // institute: { type: "select", required: true },
      documents: { type: "file" },
      // gpa: {
      //   required: true,
      //   //number: true,
      //   //minLength: 5,
      //   // maxLength: 4,
      //   // customMessages: {
      //   //   number: "Only numbers allowed in this field!",
      //   // },
      // },
      // startDate: { type: "date", required: true },
    });

  const handleSaveEducation = () => {
    const isValid = validateAllFields();
    if (isValid) {
      // console.log("Saving education details:", formData);
      // onClose(false);
      const submissionData = {
        institute: formData.institute,
        degree: formData.education,
        major: formData.fieldOfStudy,
        gpa: formData.gpa,
        startDate: formData.startDate,
        endDate: formData.endDate,
      };
      const cleanAttachments =
        Array.isArray(formData.documents) && formData.documents.length > 0
          ? formData.documents.map((file) => {
              file.id = uuidv4(); // ✅ Add id directly
              return file;
            })
          : [];

      dispatch(
        updateEmployeeStart({
          coll: "Employee",
          uiid: employeeProfileUiid,
          ...(edit
            ? { patchId: educationData?.row?._id }
            : { tPath: "educationDetails" }),
          payload: [
            {
              type: edit ? "SET" : "PUSH",
              value: {
                [edit ? `educationDetails.$[elem]` : "educationDetails"]:
                  submissionData,
              },
            },
          ],
          onSuccess: async (payload) => {
            // Step 2: Upload documents if present
            if (cleanAttachments.length > 0) {
              dispatch(
                // https://kw-workforce.s3.ap-south-2.amazonaws.com/tektree llc/workauths/101/visa/04_2025/8b09ee45e27cd2e385803d67cd33b1fd_1745471547767.pdf
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: employeeProfileUiid,
                  entity: "employees",
                  category: "education",
                  coll: "Employee",
                  doc: cleanAttachments,
                  onSuccess: (fileData) => {
                    // Step 3: Store document references
                    dispatch(
                      // addDocumentStart({
                      //   coll: "Document",
                      //   refColl: "Employee",
                      //   refId: employeeProfileUiid,
                      //   refField: `educationDetails.$[elem].documents`,
                      //   refPatchId: payload?.data.targetPatchId,
                      //   payload: {
                      //     addedBy: loginUserUiid,
                      //     attachments: cleanAttachments.map((obj) => ({
                      //       addedBy: loginUserUiid,
                      //       filePath: fileData.find(
                      //         (file) => file.fileRefId === obj.id
                      //       ).url,
                      //     })),
                      //   },
                      //   // onSuccess: handleModalClose,
                      //   onSuccess: (response) => {
                      //     console.log("Document added successfully:", response);
                      //     dispatch(
                      //       getEmployeeByUiidStart({
                      //         uiid: employeeProfileUiid,
                      //         tab: "generalEducation",
                      //         ret: "educationDetails",
                      //       })
                      //     );
                      //     handleModalClose();
                      //   },
                      // })
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Employee",
                        refId: employeeProfileUiid,
                        refField: `educationDetails.$[elem].documents`,
                        refPatchId: payload?.data.targetPatchId,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              addedBy: loginUserUiid,
                              parent: { employee: employeeProfileUiid },
                              docType: "EducationDetails",
                              ref: {
                                id: employeeProfileUiid, // parent doc uiid this doc belongs to
                                entity: "Employee", // collection name this doc belongs to
                                path: `educationDetails.${payload?.data.targetPatchId}.documents`,
                              },
                              // file: cleanAttachments.map((obj) => ({
                              //           key: fileData.find((file) => file.fileRefId === obj.id).key
                              //       }))
                              file: [
                                { keys: fileData.map((file) => file.key) },
                              ],
                            },
                          ],
                        },
                        // onSuccess: handleModalClose,
                        onSuccess: (response) => {
                          console.log("Document added successfully:", response);
                          dispatch(
                            getEmployeeByUiidStart({
                              uiid: employeeProfileUiid,
                              tab: "generalEducation",
                              ret: "educationDetails",
                              ref: "EduDoc",
                            }),
                          );
                          handleModalClose();
                        },
                      }),
                    );
                  },
                }),
              );
              handleModalClose();
            } else {
              dispatch(
                getEmployeeByUiidStart({
                  uiid: employeeProfileUiid,
                  tab: "generalEducation",
                  ret: "educationDetails",
                  ref: "EduDoc",
                }),
              );
              handleModalClose();
            }
          },
          tab: "generalEducation",
          ret: "educationDetails",
        }),
      );
    } else {
      console.log("form errors : ", errors);
    }
  };

  const handleModalClose = () => {
    // onClose(false);
    onClose(false);
    setFormData(initialFormData);
  };

  useEffect(() => {
    if (edit) {
      handleChange("education", educationData?.row.degree);
      handleChange("fieldOfStudy", educationData?.row.major);
      handleChange("institute", educationData?.row.institute);
      handleChange("gpa", educationData?.row.gpa.toString());
      handleChange("startDate", educationData?.row.startDate);
      handleChange("endDate", educationData?.row.endDate);
    } else {
      setFormData(initialFormData);
    }
  }, [edit, educationData]);
  return (
    <div>
      <Modal
        isOpen={isOpen}
        //onClose={handleModalClose}
        onClose={() => onClose(false)}
        title={`${edit ? "Edit" : "Add"} Education Details`}
        width="max-w-6xl"
      >
        <div>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 px-2 max-w-7xl">
            <FormFieldSet
              type="text"
              title="Education"
              placeholder="Enter Education"
              value={formData.education}
              onChange={(value) => handleChange("education", value)}
              error={errors.education}
              required
            />
            <FormFieldSet
              type="text"
              title="Field Of Study"
              placeholder="Enter Field Of Study"
              value={formData.fieldOfStudy}
              onChange={(value) => handleChange("fieldOfStudy", value)}
              error={errors.fieldOfStudy}
            />
            <FormFieldSet
              type="text"
              title="Institute"
              placeholder="Enter Institute"
              value={formData.institute}
              onChange={(value) => handleChange("institute", value)}
              error={errors.institute}
            />
            <FormFieldSet
              type="text"
              title="GPA/Percentage"
              placeholder="Enter GPA/Percentage"
              value={formData.gpa || ""}
              onChange={(value) => handleChange("gpa", value)}
              error={errors.gpa}
            />
            <FormFieldSet
              type="datepicker"
              title="Start Date"
              placeholder="select Start Date"
              value={formData.startDate}
              onChange={(value) => handleChange("startDate", value)}
              error={errors.startDate}
              showDropdown={false}
            />
            <FormFieldSet
              type="datepicker"
              title="End Date"
              placeholder="Enter End Date"
              value={formData.endDate}
              onChange={(value) => handleChange("endDate", value)}
              error={errors.endDate}
              showDropdown={false}
            />
            <FormFieldSet
              type="file"
              title="Documents"
              placeholder="Choose doucments"
              value={formData.documents || []}
              multiple
              onChange={(value) => handleChange("documents", value)}
              error={errors.documents}
            />
          </div>
          {edit && (
            <DocumentsList
              data={transformFiles(educationData?.row.documents || [])}
              type="inner"
            />
          )}
          <div className="flex gap-3 justify-end my-8">
            <Button
              title="Cancel"
              variant="outlined"
              //onClick={handleModalClose}
              onClick={() => onClose(!isOpen)}
            />
            <Button title="Save" onClick={() => handleSaveEducation()} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default AddEducationDetails;
